import { Injectable, inject } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Observable, tap } from 'rxjs';
import { ClockOffsetService } from '@app/core/analytics/firehose/clock-offset.service';

@Injectable({ providedIn: 'root' })
export class ClockSyncInterceptor implements HttpInterceptor {
  private readonly clockOffset = inject(ClockOffsetService);

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(req).pipe(
      tap((event) => {
        if (!this.clockOffset.synced && event instanceof HttpResponse) {
          const dateHeader = event.headers.get('Date');

          if (dateHeader) {
            this.clockOffset.sync(dateHeader);
          }
        }
      })
    );
  }
}
